export default __webpack_public_path__ + "static/media/ambient-bright-yellow-orange.a7390acd.jpg";